// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1arP0","label":"Category_label__1Dh7W","content":"Category_content__3wQ9T","header":"Category_header__1PfGn","location":"Category_location__3oMY3"};